// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"7eee0e8f","135":"035eb779","453":"d4c8b711","493":"a908601c","670":"078d2124","833":"e65b6cab","937":"ad41be65"}[chunkId] + ".chunk.js";
};